var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCardView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_9006)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8V16H8H16V8V0H8H0V8ZM1.19431 8V14.8057H8H14.8057V8V1.19431H8H1.19431V8ZM3.52607 4.30332V5.08057H4.30332H5.08057V4.30332V3.52607H4.30332H3.52607V4.30332ZM7.22275 4.30332V5.08057H8H8.77725V4.30332V3.52607H8H7.22275V4.30332ZM10.9194 4.30332V5.08057H11.6967H12.4739V4.30332V3.52607H11.6967H10.9194V4.30332ZM3.52607 8V8.77725H4.30332H5.08057V8V7.22275H4.30332H3.52607V8ZM7.22275 8V8.77725H8H8.77725V8V7.22275H8H7.22275V8ZM10.9194 8V8.77725H11.6967H12.4739V8V7.22275H11.6967H10.9194V8ZM3.52607 11.6967V12.4739H4.30332H5.08057V11.6967V10.9194H4.30332H3.52607V11.6967ZM7.22275 11.6967V12.4739H8H8.77725V11.6967V10.9194H8H7.22275V11.6967ZM10.9194 11.6967V12.4739H11.6967H12.4739V11.6967V10.9194H11.6967H10.9194V11.6967Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_9006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardView);
export default __webpack_public_path__ + "static/media/icon--card-view.5dc390d35139d82c505bf530b05cf96d.svg";
export { ForwardRef as ReactComponent };